import { useQuery } from 'react-query';
import axios from 'axios';
import { AdminAPI } from '../../../constants/API';
import { commonHeaders } from '../../../constants/HeadersAPI';

export const useGetAllSystemTopics = () => {
  const {
    data,
    isLoading,
    isError,
    error,
    isSuccess
  } = useQuery(
    ['allSystemTopics'],
    () => axios.get(AdminAPI.getAllSystemTopics, commonHeaders()).then((r) => r.data),
    {}
  );

  return {
    allSystemTopics: data ?? [],
    isLoadingAllSystemTopics: isLoading,
    isAllSystemTopicsRecieved: isSuccess,
    isErrorAllSystemTopics: isError,
    allSystemTopicsError: error
  };
};
